<template>
  <el-dialog
    title="账号信息编辑"
    :visible.sync="_dialogVisible"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    @close="closeDialog"
    width="500px"
  >
    <el-form
      :model="listParams"
      ref="listForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="账号：">
        <span>{{ listParams.username }}</span>
      </el-form-item>

      <el-form-item label="名称：">
        <span>{{ listParams.title }}</span>
      </el-form-item>

      <el-form-item label="手机号：" prop="mobile">
        <el-input
          placeholder="请输入手机号"
          :maxlength="11"
          v-model.trim="listParams.mobile"
          class="w200"
          clearable
        />
      </el-form-item>

      <el-form-item label="新密码：" prop="password">
        <el-input
          placeholder="请输入密码"
          :maxlength="18"
          v-model.trim="listParams.password"
          class="w300"
          clearable
        >
          <template slot="append">
            <el-button @click="handleRandomPassword">
              随机密码
            </el-button>
          </template>
        </el-input>
        <div class="tip">8-18位，包含数字、字母和特殊字符!@#$%^&*</div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="_dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import md5 from "js-md5";
import Vue from "vue";

const passwordReg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)(?![a-zA-z\d]+$)(?![a-zA-z!@#$%^&*]+$)(?![\d!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]{8,18}$/i;
const passwordChatConfig =
  "0123456789abcdefghijklm0123456789nopqrstuvwxyz0123456789ABCDEFGHIJKLM0123456789NOPQRSTUVWXYZ0123456789!@#$%^&*";

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      }
    }
  },

  watch: {
    _dialogVisible: {
      immediate: true,
      handler(value) {
        if (value && this.dialogData && this.dialogData.adminAccountId) {
          Object.assign(this.listParams, { ...this.dialogData });
        }
      }
    }
  },

  data() {
    return {
      btnLoading: false,
      listParams: {
        adminAccountId: "",
        title: "",
        username: "",
        password: "",
        mobile: ""
      },
      rules: {
        password: [
          {
            required: false,
            message: "请输入完整的密码",
            pattern: passwordReg,
            trigger: "change"
          }
        ]
      }
    };
  },

  methods: {
    /**
     * 随机密码
     */
    handleRandomPassword() {
      const length = 8;
      function getPassword() {
        let result = "";
        for (let i = 0; i < length; i++) {
          const pos = Math.round(
            Math.random() * (passwordChatConfig.length - 1)
          );
          result += passwordChatConfig.charAt(pos);
        }
        return result;
      }
      let newPassword = getPassword();
      while (!passwordReg.test(newPassword)) {
        newPassword = getPassword();
      }
      this.listParams.password = newPassword;
    },
    /**
     * 提交更新
     */
    handleSubmit() {
      this.$refs.listForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          const data = { ...this.listParams };
          const password = data.password;
          if (password) {
            data.password = md5(password).toUpperCase();
          }
          const url = `${global.apiUrl}/adminaccount/updatePwdAndMobile`;
          Vue.ajaxPut(this, url, { ...data })
            .then(response => {
              if (response.apiStatus === 0 && response.sysStatus === 0) {
                this.$message.success(response.info);
              } else {
                this.$message({ message: response.info, type: "error" });
              }
              this.btnLoading = false;
              this._dialogVisible = false;
              this.$emit("refresh");
            })
            .catch(error => {
              console.log(error);
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 关闭
     */
    closeDialog() {
      this.$refs.listForm.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.tip {
  color: #999;
  font-size: 12px;
}
</style>
